import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[preventDoubleClick]',
})
export class PreventDoubleClickDirective {

  constructor() {
    console.log("prevent-double-click");
  }
  @HostListener('click', ['$event'])
  clickEvent(event) {
    let e = event.currentTarget;
    event.currentTarget.disabled = true;
    setTimeout(function () {
      e.disabled = false;
    }, 1000);
  }
}
